"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RApp = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var CEKValue_1 = require("../CEKValue/CEKValue.js");
var RApp = /** @class */ (function () {
    function RApp(arg, env, src) {
        (0, obj_utils_1.defineReadOnlyProperty)(this, "arg", arg);
        this.env = env;
        this.src = src;
    }
    RApp.prototype.clone = function () {
        return new RApp(this.arg.clone(), this.env.clone(), this.src);
    };
    RApp.prototype.isRightAppToValue = function () {
        return (0, CEKValue_1.isCEKValue)(this.arg);
    };
    return RApp;
}());
exports.RApp = RApp;
